import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { CalendarCanvas } from '@/features/app-shell/canvases/calendar-canvas'

export const Route = createFileRoute('/app/calendar')({
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppCalendarPage,
})

function AppCalendarPage() {
  return <CalendarCanvas />
}
